import { useState, useEffect } from 'react';
import { offlinePasswordRepository } from '../repositories/offlinePassword.repository';

export const useOfflinePassword = (authToken, userToken, deviceId) => {
  const [passwords, setPasswords] = useState([]);

  const load = async () => {
    const cached =
      await offlinePasswordRepository.getFromCache(
        userToken,
        deviceId
      );

    setPasswords(cached);
  };

  useEffect(() => {
    load();
  }, []);

  return { passwords, reload: load };
};
